import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface EdgeLabelFormButtonsProps {
  onCancel: () => void
}

export const EdgeLabelFormButtons = ({ onCancel }: EdgeLabelFormButtonsProps): ReactNode => (
  <div className="flex justify-end gap-2">
    <Button type="button" variant="ghost" size="sm" onClick={onCancel}>
      Cancel
    </Button>
    <Button type="submit" size="sm">
      Save
    </Button>
  </div>
)

EdgeLabelFormButtons.displayName = 'EdgeLabelFormButtons'
